<template>
  <div class="nav">
    <h3>导航</h3>
    <dl>
      <dt></dt>
      <dd>
        
        <router-link to="/app_lives/center/id/46">老师个人主页</router-link>
        <router-link to="/lives/center/id/1153">高手个人主页</router-link>
        <router-link to="/ucenter/user_home/m_u_id/246289">达人个人主页</router-link>
        
        <router-link to="/up/iNewsList">资讯列表</router-link>
        <router-link to="/up/tops">排行榜</router-link>
      </dd>
    </dl>
    <dl>
      <dt>智能诊股</dt>
      <dd>
        <router-link to="/up/Intelligent_diagnosis_stock">首页</router-link>
        <router-link to="/up/Intelligent_diagnosis_stock/notBuy"
          >未购买</router-link
        >
        <router-link to="/up/Intelligent_diagnosis_stock/1">已购买</router-link>
      </dd>
      <dt>跳转到原生页面</dt>
      <dd>
        <a href="?funToApp&jump_l_id=46">老师个人主页 jump_l_id</a>
        <a href="?funToApp&jump_u_id=317961">用户个人主页 jump_u_id</a>

        <a href="?funToApp&l_id=333582#AiGuPiao_DirectMessages">运营专员</a>
        <a href="?funToApp&l_id=108388#AiGuPiao_DirectMessages">爱股票小秘书</a>

        <a href="?funToApp&kind=profit_rank&id=1">模拟炒股排行榜</a>

<!-- 这几个估计是特定页面用的 -->
        <span @click="navigatAppTo('custom_operate', '')">咨询运营专员</span>
        <span @click="navigatAppTo('withdrawal', '')">立即提现</span>
        <span @click="navigatAppTo('custom_service', '')">联系客服</span>
      </dd>
    </dl>
    <div>
      userAgent:
      {{userAgent}}
    </div>
  </div>
</template>

<script>
// import "@/utils/flexible";
export default {
  data(){
    return {
      userAgent: navigator.userAgent
    }
  },
  methods:{
    navigatAppTo(tag, id) {
      this.$igpJumpToNative(tag, id);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.nav {
  height: 100vh;
  h3 {
    text-align: center;
    font-size: rem2(30px);
    font-weight: bold;
    line-height: 2em;
  }
  font-size: rem2(26px);
  dl {
    padding-left: rem2(25px);
    line-height: 1.4em;
    dd {
      a {
        padding-right: rem2(20px);
      }
      a,
      span {
        display: inline-block;
        background: #b1a9a9;
        color: #fff;
        padding: rem2(5px);
        margin: rem2(15px) rem2(10px);
        border-radius: rem2(5px);
      }
    }
  }
}
</style>